import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { TiInfoOutline } from "react-icons/ti";

export default function ConfirmPopup({
  showPromptElement,
  setShowPromptElement,
  submitHandler,
}) {
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPromptElement ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-sm w-full h-auto uppercase  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col">
        <TiInfoOutline className="text-center text-red" size={"3rem"} />
        <h2 className="text-xl font-medium p-4 pb-1 text-center">
          Are you sure ?
        </h2>
        {/* <p>You won't be able to revert this!</p> */}
        <div className="flex gap-3 w-full px-5 mt-5">
          <button
            className="p-1 w-full max-w-sm uppercase rounded-md ring-1 ring-slate-600 text-sm"
            onClick={() => {
              setShowPromptElement(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-1 w-full max-w-sm uppercase rounded-md ring-1 ring-red disabled:bg-rose-400 text-white text-sm bg-red"
            onClick={async () => {
              setShowPromptElement(false);
              submitHandler(null, true);
            }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
